// extracted by mini-css-extract-plugin
export var active = "SaveToOfflineSidebar-module--active--cee02";
export var arrow = "SaveToOfflineSidebar-module--arrow--31e6b";
export var arrowNo = "SaveToOfflineSidebar-module--arrow_no--3f00a";
export var arrowYes = "SaveToOfflineSidebar-module--arrow_yes--fa9ce";
export var backgroundOverlay = "SaveToOfflineSidebar-module--backgroundOverlay--ba87b";
export var checkboxWrapper = "SaveToOfflineSidebar-module--checkboxWrapper--e1188";
export var collectionDescription = "SaveToOfflineSidebar-module--collectionDescription--ca89c";
export var collectionTitle = "SaveToOfflineSidebar-module--collectionTitle--beb29";
export var containerLabel = "SaveToOfflineSidebar-module--containerLabel--4f852";
export var contentTypes = "SaveToOfflineSidebar-module--contentTypes--df78b";
export var contentWrapper = "SaveToOfflineSidebar-module--contentWrapper--62632";
export var customContainer = "SaveToOfflineSidebar-module--customContainer--10047";
export var description = "SaveToOfflineSidebar-module--description--00cde";
export var detailsWrapper = "SaveToOfflineSidebar-module--detailsWrapper--0a3f7";
export var divider = "SaveToOfflineSidebar-module--divider--df091";
export var documentDropdown = "SaveToOfflineSidebar-module--documentDropdown--4bdb4";
export var documentDropdownHeader = "SaveToOfflineSidebar-module--documentDropdownHeader--8812b";
export var documentItemWrapper = "SaveToOfflineSidebar-module--documentItemWrapper--cfe9a";
export var documentItemsContainer = "SaveToOfflineSidebar-module--documentItemsContainer--3d003";
export var downloadIconWrapper = "SaveToOfflineSidebar-module--downloadIconWrapper--61796";
export var downloadTextWrapper = "SaveToOfflineSidebar-module--downloadTextWrapper--62b74";
export var downloadWrapper = "SaveToOfflineSidebar-module--downloadWrapper--8f26f";
export var dropdownChevronIcon = "SaveToOfflineSidebar-module--dropdownChevronIcon--0a598";
export var dropdownContent = "SaveToOfflineSidebar-module--dropdownContent--a1d18";
export var dropdownTitle = "SaveToOfflineSidebar-module--dropdownTitle--bec71";
export var flex = "SaveToOfflineSidebar-module--flex--53cbc";
export var flex1 = "SaveToOfflineSidebar-module--flex_1--798ab";
export var flexCenter = "SaveToOfflineSidebar-module--flex_center--a0bd8";
export var flexCenterCol = "SaveToOfflineSidebar-module--flex_center_col--67965";
export var flexCol = "SaveToOfflineSidebar-module--flex_col--39787";
export var flexFixCenterCol = "SaveToOfflineSidebar-module--flex_fix_center_col--e0b4f";
export var flexFixedCenterCol = "SaveToOfflineSidebar-module--flex_fixed_center_col--4d9ef";
export var hiddenIcon = "SaveToOfflineSidebar-module--hiddenIcon--6bc3e";
export var image = "SaveToOfflineSidebar-module--image--b4b60";
export var imageContent = "SaveToOfflineSidebar-module--imageContent--190b2";
export var imageWrapper = "SaveToOfflineSidebar-module--imageWrapper--3adfe";
export var langIcon = "SaveToOfflineSidebar-module--langIcon--1c494";
export var menuItemTitle = "SaveToOfflineSidebar-module--menuItemTitle--cf689";
export var navigationItemIcon = "SaveToOfflineSidebar-module--navigationItemIcon--b5465";
export var offset = "SaveToOfflineSidebar-module--offset--aad7e";
export var open = "SaveToOfflineSidebar-module--open--9bd04";
export var pdfItem = "SaveToOfflineSidebar-module--pdfItem--6af16";
export var primaryMenuWrapper = "SaveToOfflineSidebar-module--primaryMenuWrapper--7aad7";
export var rotating = "SaveToOfflineSidebar-module--rotating--df4ea";
export var sectionDivider = "SaveToOfflineSidebar-module--sectionDivider--ea24d";
export var selected = "SaveToOfflineSidebar-module--selected--1bc63";
export var sidebar = "SaveToOfflineSidebar-module--sidebar--fed35";
export var sidebarCloseButton = "SaveToOfflineSidebar-module--sidebarCloseButton--4063c";
export var sidebarCloseIcon = "SaveToOfflineSidebar-module--sidebarCloseIcon--04bea";
export var sidebarTopWrapper = "SaveToOfflineSidebar-module--sidebarTopWrapper--b67b5";
export var sidebarWrapper = "SaveToOfflineSidebar-module--sidebarWrapper--b2186";
export var tab = "SaveToOfflineSidebar-module--tab--9a9d8";
export var tabLabel = "SaveToOfflineSidebar-module--tabLabel--6e5c4";
export var tabRow = "SaveToOfflineSidebar-module--tabRow--f69a3";
export var tabWrapper = "SaveToOfflineSidebar-module--tabWrapper--7e9c2";
export var title = "SaveToOfflineSidebar-module--title--d0ca1";
export var titleWrapper = "SaveToOfflineSidebar-module--titleWrapper--f47d3";
export var uploading = "SaveToOfflineSidebar-module--uploading--2ee18";